import script from "./RichEditorToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./RichEditorToolbar.vue?vue&type=script&setup=true&lang=js"

import "./RichEditorToolbar.vue?vue&type=style&index=0&id=7374192c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7374192c"]])

export default __exports__